import { RequestAction } from '@redux-requests/core';
import { gql } from '@redux-requests/graphql';
import { AppsConstants } from '../constants';

export type DeveloperAppVerb =
  | 'REQUEST_APPROVAL'
  | 'CANCEL_APPROVAL'
  | 'PUBLISH'
  | 'UNPUBLISH'
  | 'PENDING';

export const changeDeveloperAppStatus = (
  appId: string,
  appVerb: DeveloperAppVerb,
  note?: string
): RequestAction => ({
  type: AppsConstants.APP_CHANGE_STATUS,
  request: {
    query: gql`
      mutation ($appId: ID!, $appVerb: DeveloperAppVerb!, $note: String) {
        changeDeveloperAppStatus(appId: $appId, appVerb: $appVerb, note: $note)
      }
    `,
    variables: { appId, appVerb, note },
  },
  meta: {
    getData: ({ changeDeveloperAppStatus }) => changeDeveloperAppStatus,
  },
});
